import usePaymentsApi from "../../hooks/usePaymentsApi";
import TooltipButton from "views/Documents/components/TooltipButton";
import { MdDelete } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import useNotification from "utils/hooks/useNotification";

interface RemoveButtonPropsTypes {
  id?: ID;
  refetch?: () => void;
}

export default function RemoveButton({ id, refetch }: RemoveButtonPropsTypes) {
  const { t } = useTranslation();
  const { deletePayment } = usePaymentsApi();
  const { notificationError } = useNotification();

  const confirmDelete = (id: ID) => {
    Modal.confirm({
      title: t("Delete payment"),
      content: t("Are you sure about delete this payment?"),
      okText: t("Yes"),
      okType: "danger",
      onOk: () => handleOk(id),
    });
  };

  const handleOk = async (id: ID) => {
    const response = await deletePayment({
      variables: {
        id,
      },
    });

    const errors = response?.data?.deletePayment.errors;
    notificationError(errors);
    refetch!();
  };

  return <TooltipButton variant="delete" placement="top" handleOnClick={() => confirmDelete(id)} icon={<MdDelete />} />;
}
